import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getFleets } from 'app/entities/fleet/fleet.reducer';
import { ITenant } from 'app/shared/model/tenant.model';
import { getEntities as getTenants } from 'app/entities/tenant/tenant.reducer';
import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/modules/administration/user-management/user-management.reducer';
import { IFleet } from 'app/shared/model/fleet.model';
import { getEntity, updateEntity, createEntity, reset } from './fleet.reducer';

export const FleetUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const fleets = useAppSelector(state => state.fleet.entities);
  const tenants = useAppSelector(state => state.tenant.entities);
  const users = useAppSelector(state => state.userManagement.users);
  const fleetEntity = useAppSelector(state => state.fleet.entity);
  const loading = useAppSelector(state => state.fleet.loading);
  const updating = useAppSelector(state => state.fleet.updating);
  const updateSuccess = useAppSelector(state => state.fleet.updateSuccess);

  const handleClose = () => {
    navigate('/fleet');
  };

  useEffect(() => {
    if (!isNew) {
      dispatch(getEntity(id));
    }

    dispatch(getFleets({}));
    dispatch(getTenants({}));
    dispatch(getUsers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  // eslint-disable-next-line complexity
  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }

    const entity = {
      ...fleetEntity,
      ...values,
      parent: fleets.find(it => it.id.toString() === values.parent?.toString()),
      tenant: tenants.find(it => it.id.toString() === values.tenant?.toString()),
      owner: users.find(it => it.id.toString() === values.owner?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...fleetEntity,
          parent: fleetEntity?.parent?.id,
          tenant: fleetEntity?.tenant?.id,
          owner: fleetEntity?.owner?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="cabmanApp.fleet.home.createOrEditLabel" data-cy="FleetCreateUpdateHeading">
            <Translate contentKey="cabmanApp.fleet.home.createOrEditLabel">Create or edit a Fleet</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="fleet-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('cabmanApp.fleet.name')}
                id="fleet-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 64, message: translate('entity.validation.maxlength', { max: 64 }) },
                  pattern: { value: /^[a-zA-Z0-9]*$/, message: translate('entity.validation.pattern', { pattern: '^[a-zA-Z0-9]*$' }) },
                }}
              />
              <ValidatedField id="fleet-parent" name="parent" data-cy="parent" label={translate('cabmanApp.fleet.parent')} type="select">
                <option value="" key="0" />
                {fleets
                  ? fleets.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField id="fleet-tenant" name="tenant" data-cy="tenant" label={translate('cabmanApp.fleet.tenant')} type="select">
                <option value="" key="0" />
                {tenants
                  ? tenants.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField id="fleet-owner" name="owner" data-cy="owner" label={translate('cabmanApp.fleet.owner')} type="select">
                <option value="" key="0" />
                {users
                  ? users.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.login}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/fleet" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default FleetUpdate;
